/**
 * Shared transient feedback queue for the global `<v-snackbar-queue>` in
 * App.vue. Items auto-dismiss after their timeout — used for confirming
 * user-initiated actions like task/build cancellation.
 */
import { ref } from "vue";

export type FeedbackType = "success" | "error" | "info";

export interface FeedbackItem {
	text: string;
	class: string;
	timeout: number;
	feedbackType: FeedbackType;
}

const transientFeedbackQueue = ref<FeedbackItem[]>([]);

/**
 * Error messages get a longer timeout (4s) because they require the user
 * to read and understand what went wrong. Success/info are quick
 * confirmations (2.5s).
 */
export function pushFeedback(message: string, type: FeedbackType): void {
	transientFeedbackQueue.value.push({
		text: message,
		class: `snackbar-${type}`,
		timeout: type === "error" ? 4000 : 2500,
		feedbackType: type,
	});
}

export function useFeedbackQueue() {
	return { transientFeedbackQueue };
}
